var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calendar-card"},[_c('img',{attrs:{"src":"/images/promo/connect-features/calendar-card.svg","alt":"Calendar card"}})])}]

export { render, staticRenderFns }